import React from 'react';

type Props = {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  renderPreview?: () => React.ReactNode;
  previewKey?: string | number;
};

const BlockSettingsModal: React.FC<Props> = ({ open, title, onClose, children, renderPreview, previewKey }) => {
  const [showPreview, setShowPreview] = React.useState(true);
  React.useEffect(() => { if (open) setShowPreview(true); }, [open]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative z-10 w-[min(1100px,96vw)] max-h-[88vh] bg-white rounded-2xl shadow-2xl border border-gray-200 flex flex-col">
        <div className="flex items-center gap-2 px-5 py-3 border-b border-gray-100">
          <div className="font-semibold text-gray-900">{title}</div>
          <div className="ml-auto inline-flex items-center gap-1">
            {!!renderPreview && (
              <button
                className={`inline-flex items-center gap-2 rounded-md border px-3 py-1.5 text-sm ${showPreview ? 'border-purple-300 text-purple-700 bg-purple-50' : 'border-gray-200 text-gray-700 hover:bg-gray-50'}`}
                title={showPreview ? 'Hide preview' : 'Show preview'}
                onClick={()=> setShowPreview(v=>!v)}
              >
                <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z"/><circle cx="12" cy="12" r="3"/></svg>
                Preview
              </button>
            )}
            <button className="inline-flex h-8 w-8 items-center justify-center rounded-md hover:bg-gray-100" onClick={onClose}>
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
        </div>
        <div className={`flex-1 overflow-hidden ${showPreview ? 'grid grid-cols-1 lg:grid-cols-2' : ''}`}>
          <div className={`p-5 overflow-auto ${showPreview ? 'border-r border-gray-100' : ''}`}>
            {children}
          </div>
          {showPreview && (
            <div className="p-5 overflow-auto bg-gray-50">
              <div className="max-w-3xl mx-auto" key={previewKey}>
                {renderPreview?.()}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlockSettingsModal;
